import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PingWidgetComponent } from './ping-widget.component';
import { RouterModule } from '@angular/router';
import {
    TgButtons2Module,
    TgIconBasicArrowDownModule,
    TgIconBasicCrossModule,
    TgIconKeyModule,
    TgInputModule,
    TgRackModule,
    TgSpacingModule,
    TgSvgModule,
    TgSwitchModule,
    TgIconCreditCardAddModule
} from '@trademe/tangram';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,

        TgButtons2Module,
        TgIconBasicArrowDownModule,
        TgIconBasicCrossModule,
        TgIconKeyModule,
        TgInputModule,
        TgRackModule,
        TgSpacingModule,
        TgSvgModule,
        TgSwitchModule,
        TgIconCreditCardAddModule
    ],
    declarations: [PingWidgetComponent],
    exports: [PingWidgetComponent]
})
export class PingWidgetModule {}
